import { ThemeOptions } from '@mui/material';

export const themeSelect: ThemeOptions['components'] = {
  MuiSelect: {
    styleOverrides: {
      select: {
        boxSizing: 'border-box',
        textAlign: 'left',
      },
      icon: ({ theme }) => ({
        color: theme.palette.primary.main,
      }),
    },
  },
};
